/**
 * 技巧视频相关的打点
 */

export default {
  /**
   * 【技巧视频列表页】
   * 页面点击事件
   *  @param {*} click
   *  firstclass|上报一级分类关键词;
      secondclass|上报二级分类关键词;
      thirdclass|上报三级分类关键词;
      default|默认;
      number|学习人数;
      time|发布时间;
      collect|收藏人数;
      @param {*} keyword：关键词
      @param {*} type：教程ID
   */
  listSkillClick({
    click,
    keyword,
    type
  }) {
    this.collect('list_video_click', {
      click,
      keyword,
      type
    });
  },

  listSkillShow({
    show
  }) {
    this.collect('list_video_show', {
      show
    });
  },
}
